const strings = {
  labels: {
    messageDeliveryError: 'Message not delivered',
    retry: 'Retry',
  },
} as const;

export default strings;
